<div class="d-flex exemplar-listing">
  <div class="col-10 text-wrapped px-0">
    <div class="float-left col-num">
      <p class="text-wrapped title font-bold mb-0">{{ serialNo + 1 }}.</p>
    </div>

    <div class="float-left col-data">
      <p class="title font-bold mb-0" *ngIf="exemplarData.title">{{ exemplarData.title }}</p>
      <p class="mb-2" *ngIf="exemplarData.description && viewLocation !== 'document-upload'">{{ exemplarData.description }}</p>
      <div class="hide-content" *ngIf="exemplarData.description && viewLocation === 'document-upload'"
        [innerHtml]="exemplarData.description"></div>

      <p *ngIf="exemplarData.has_asset===0">
        <a href="{{exemplarData.external_url}}" class="text-link text-underline" id="URL_{{ serialNo + 1 }}"
          target="_blank" rel="noopener"
          aria-label="Click to preview the URL"
          [class.cursor-deny]="viewLocation === 'front-facing' ? false : (!preventEdit ? (viewMode!=='edit' || canPreview) : true)">{{exemplarData.external_url}}
        </a>
      </p>

      <div class="col-12 px-0" *ngIf="exemplarData.has_asset===1">
        <ul class="list-inline mb-0">
          <li class="list-inline-item max-w-50 text-truncate mr-0">{{ exemplarData.asset_file_name }}</li>
          <li class="list-inline-item text-truncate"><span
              class="bytes">{{formatBytes(exemplarData.asset_size_in_bytes)}}</span></li>
        </ul>

        <ul class="list-inline mb-0"
          *ngIf="viewLocation === 'front-facing' ? true: (!preventEdit ? ((viewMode==='edit' && !isRightPanel) || canPreview) : false)">
          <li class="list-inline-item mr-3">
            <a href="{{exemplarData.external_url}}" target="_blank" id="Preview_{{ serialNo + 1 }}"
              aria-label="Click to preview asset" rel="noopener"
              class="text-link text-underline">Preview</a>
          </li>
          <li class="list-inline-item mr-0"
            *ngIf="viewLocation === 'front-facing' ? true: (!preventEdit ? (viewMode==='edit' && !isRightPanel) : false)">
            <a href="{{exemplarData.external_download_url}}" target="_self" id="Download_{{ serialNo + 1 }}"
              aria-label="Click to download asset"
              class="text-link text-underline">Download</a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="col-2 text-right px-0">
    <button *ngIf="showDelete" class="btn btn-icon tooltip top position-relative d-inline-block"
      data-tooltip="Delete asset" [attr.aria-label]="'Delete asset'" id="deleteAssetBtn_{{ serialNo + 1 }}"
      (click)="onDelteExemplar((option==='Document') ? exemplarData.asset_id : exemplarData.association_id)">
      <em class="material-icons-outlined font-4x" aria-hidden="true">delete</em>
    </button>
  </div>
</div>
